"use strict";
var ForkJoinObservable_1 = require('./ForkJoinObservable');
exports.forkJoin = ForkJoinObservable_1.ForkJoinObservable.create;
//# sourceMappingURL=forkJoin.js.map


//////////////////
// WEBPACK FOOTER
// C:/firebase/gbord/~/rxjs/observable/forkJoin.js
// module id = ../../../../rxjs/observable/forkJoin.js
// module chunks = 3